import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-homeone-services',
    templateUrl: './homeone-services.component.html',
    styleUrls: ['./homeone-services.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeoneServicesComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: 'Our Services',
            title: 'We Offer Professional Solutions For Business',
            paragraphText: 'Our skilled tech resources would get involve with yiu and provide the best solution for your business needs.'
        }
    ]
    singleServicesBox: ServicesBoxContent[] = [

        {
            icon: 'assets/img/services/icon5.png',
            title: 'Web Development',
            paragraphText: 'At Devotory, we provide end-to-end web development services across all major frameworks and technologies, ensuring a tailored approach to meet your unique needs.',
            link: 'services-details/1',
            linkText: 'Read More',
            linkIcon: 'flaticon-right'
        },
        {
            icon: 'assets/img/services/icon1.png',
            title: 'Dedicated Development Team',
            paragraphText: 'We provide dedicated development teams at competitive hourly rates, giving you access to top-tier talent without the overhead of traditional hiring. Our developers are highly skilled and bring a wealth of experience to your projects.',
            link: 'services-details/2',
            linkText: 'Read More',
            linkIcon: 'flaticon-right'
        },
        {
            icon: 'assets/img/services/icon2.png',
            title: 'AI & ML Development',
            paragraphText: 'At Devotory, we excel in developing cutting-edge AI applications that drive innovation and deliver impactful results. Our expertise spans a range of AI technologies and methodologies, tailored to meet your specific needs.',           
            link: 'services-details/3',
            linkText: 'Read More',
            linkIcon: 'flaticon-right'
        },
        // {
        //     icon: 'assets/img/services/icon3.png',
        //     title: 'Data Science',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        //     link: 'services-details',
        //     linkText: 'Read More',
        //     linkIcon: 'flaticon-right'
        // },
        // {
        //     icon: 'assets/img/services/icon4.png',
        //     title: 'Predictive Analytics',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        //     link: 'services-details',
        //     linkText: 'Read More',
        //     linkIcon: 'flaticon-right'
        // },
        // {
        //     icon: 'assets/img/services/icon6.png',
        //     title: 'Elastic Solutions',
        //     paragraphText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.',
        //     link: 'services-details',
        //     linkText: 'Read More',
        //     linkIcon: 'flaticon-right'
        // }
    ]
    loadMoreBtn: loadMore[] = [
        {
            link: 'services',
            linkText: 'Load More',
            linkIcon: 'flaticon-refresh'
        }
    ]

}
class sectionTitleContent {
    subTitle : string;
    title : string;
    paragraphText : string;
}
class ServicesBoxContent {
    icon : string;
    title : string;
    paragraphText : string;
    link : string;
    linkText : string;
    linkIcon : string;
}
class loadMore {
    link : string;
    linkText : string;
    linkIcon : string;
}